import { Button01 } from "@src/components/button";
import { DrawerContext } from "@src/screens/drawer-screens/drawer-provider";
import React, { useContext, useState } from "react";
import { Text, View, } from "react-native";
import { mobileSize } from "@src/utils/screensize-helper";
import useStyles from "./styles.css";
import BannerModal from './banner-modal'
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectSubscriptionActive } from "@src/ducks/slices/user.slice";
import { TouchableOpacity } from "react-native-gesture-handler";

type Props = {
  title: string;
  description: string;
  button: any;
}

const BannerContent= ({ title, description, button }: Props) => {
  const styles = useStyles();
  const isMobile = mobileSize();
  const { onActiveTab } = useContext(DrawerContext);
  const isSubscribeActive = useAppSelector(selectSubscriptionActive);
  const [showModal, setShowModal] = useState(false)

  const onUpgrade = () => {
    if (isSubscribeActive) {
      onActiveTab("FAQs")
      return
    }
    onActiveTab("Upgrade Plan")
    // setShowModal(true)
  }

  return (
    <View style={styles.bg_content2}>
      <Text style={styles.textContent2}>
        {/* GET FREE TRIAL */}
        {/* {!isSubscribeActive &&
          <>
            <Text style={styles.boldText}>
              Upgrade now to enjoy all features of SignSecure!{`\n`}
            </Text>
            <Text style={styles.smallText}>
              Create, manage, and send multiple documents with better storage when you upgrade.
            </Text>
          </>
        } */}

        <View style={{ flex: 1,}}>
          <Text style={styles.boldText}>
            {title}{`\n`}
          </Text>
          <View style={{ height: 5, }} />
          <Text style={styles.smallText}>
            {description}{" "}
            {button?.type === "underlineText" && 
              <TouchableOpacity onPress={button.onPress} style={{ cursor:'pointer'} as any}>
                <Text style={[styles.smallText, { color: 'white', textDecorationLine: 'underline', }]}>{button.title}</Text>
              </TouchableOpacity>
            }
          </Text>
        </View>
      </Text>
      {/* {!isSubscribeActive &&  */}
      {button?.type === "button" &&
        <Button01
          // label={isSubscribeActive ? "Get It Now" : "Upgrade Now"}
          // onPress={isSubscribeActive ? () => { } : onUpgrade}
          label={button.title}
          onPress={button.onPress}
          style={[styles.btn_learnmore2, { flex: button?.size ?? 0.3}]}
          labelStyle={styles.btn_label}
        />
      }
    </View>
  );
};

export default BannerContent;